'use strict';

function Week1ResidentialCareTypeFactory(RespiteCareType, constants) {

  function Week1ResidentialCareType(userInputModel) {
    var respiteCareType = new RespiteCareType(userInputModel);

    this.getTotalWeeklyExpenses = function () {
      return respiteCareType.getTotalWeeklyExpenses();
    };

    this.getPartnerMinimumIncomeGuarantee = function (results) {
      return respiteCareType.getPartnerMinimumIncomeGuarantee(results);
    };

    this.personalLivingAllowance = function (results) {
      return respiteCareType.personalLivingAllowance(results);
    };

    this.getDisregardedAttendanceAllowance = function () {
      return respiteCareType.getDisregardedAttendanceAllowance();
    };

    this.getDisregardedPrivatePension = function () {
      return respiteCareType.getDisregardedPrivatePension();
    };

    this.getDisregardedCarersPremium = function (isEntitledToPremium, carersAllowance) {
      return respiteCareType.getDisregardedCarersPremium(isEntitledToPremium, carersAllowance);
    };

    this.getChildrensPremium = function () {
      return respiteCareType.getChildrensPremium();
    };

    this.getDisregardedPensionSavingsCredit = function (userType, results) {
      var respiteValue = respiteCareType.getDisregardedPensionSavingsCredit(userType, results);
      return Math.min(constants.pensionCreditAllowances.maxDisregardSingle, respiteValue);
    };

    this.getAllowableWorkingTaxCredit = function (workingTaxCreditIncome) {
      return userInputModel.isCouple() ? workingTaxCreditIncome / 2 : workingTaxCreditIncome;
    };

    /**
     * https://docs.google.com/spreadsheets/d/18IC99SA-bWsKc5J-oxatnQ756-iw64A8GuQD_oF37Xs/edit#gid=0
     *
     * @param contributionUpperBound
     * @param results
     */
    this.adjustContribution = function (contributionUpperBound, results) {

      var applicantData = userInputModel.getApplicantData();
      var hasPartner = userInputModel.isCouple();

      var housingCosts = ['rent', 'councilTax', 'waterRates', 'homeContentsInsurance', 'groundRent'].reduce(
        function (runningTotal, expenseType) {
          return runningTotal + userInputModel.getWeeklyExpense(expenseType);
        }, 0);

      housingCosts = hasPartner ? housingCosts / 2 : housingCosts;

      contributionUpperBound += housingCosts;

      contributionUpperBound += applicantData.getWeeklyIncome('attendanceAllowance');

      var savingsThreshold = constants.residential.totalSavingsThreshold;
      var individualCapital = applicantData.individualCapital + (0.5 * userInputModel.getJointCapital());

      return individualCapital >= savingsThreshold || applicantData.hasAdditionalProperties ?
        constants.maxWeeklyContribution : contributionUpperBound;
    };
  }

  return Week1ResidentialCareType;
}

Week1ResidentialCareTypeFactory.$inject = ['RespiteCareType', 'kirkleesCareAssessmentConstants'];

angular.module('kerp-forms.forms').factory('Week1ResidentialCareType', Week1ResidentialCareTypeFactory);
